import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { RootState } from '../app/store';
import { useEffect } from 'react';
import { updateUser } from '../features/auth/userSlice';

const PrivateRoutes = () => {
    const dispatch = useDispatch();
    const isAuthenticated: any = useSelector((state: RootState) => state.auth);

    useEffect(() => {
        if (!isAuthenticated.value) {
            dispatch(updateUser({}));
            let urlAuthProvide = String(process.env.REACT_APP_AUTH_PROVIDER);
            let urlRedirect = String(process.env.REACT_APP_URL_REDIRECT);
            let url = `${urlAuthProvide}oauth/logout?post_logout_redirect_uri=${urlRedirect}`;
            document.location.href = url;
        }
    }, [isAuthenticated.value])

    return (
        isAuthenticated.value ?
            <Outlet />
            :
            <Navigate to="/login" />
    )
}
export default PrivateRoutes;